// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scale-reduce[data-v-1fd968aa] {\n  -webkit-transform: scale(0.625);\n          transform: scale(0.625);\n  -webkit-transform-origin: 50% 80%;\n          transform-origin: 50% 80%;\n}\n[data-v-1fd968aa] .selected-row {\n  background: #e2f5fb;\n}", ""]);
// Exports
module.exports = exports;
